import React from 'react';
import {Link} from 'react-router-dom';
import classnames from 'classnames';
import styles from './styles.module.css';

const ProductTypeCard = ({
    productType: {
        id,
        name,
        photo: {url: photoUrl}={}
    } = {}
}) => (
    <Link to={`/produtos/tipos/${id}`}>
        <div 
            key={id}
            className={styles.serviceCard}>
            <div className={styles.imageWrapper}>
                <div className={classnames(styles.serviceImage, styles.rotateBox)}>
                    <img src={photoUrl}/>
                </div>
            </div>
                <div className={styles.serviceCardName}>
                    {name}
                </div>        
        </div>
    </Link>
);

export default ProductTypeCard;